<template>
    <div class="invite_main">
        <div class="invite_header">
            <div class="icon">
                <div class="eng">广州劳动仲裁院</div>
                <div>GUANGZHOU LABOR ARBITRATION COURT</div>
            </div>
            <div class="title">广州劳动人事微仲裁</div>
        </div>
        <div class="invite_content">
            <div class="invite-login">
							<div class="rightItem">
								<el-input class="input" v-model="resetform.phonenum" maxlength="11" @keyup.enter="golost"
                        placeholder="请输入手机号" autocomplete="new-password"/>
              	<div class='validateTip'>{{validatetip2.phonenum}}</div>
							</div>
							<div class="rightItem">
									<el-input class="speacail" v-model="resetform.code" @keyup.enter="golost" maxlength="6"
														placeholder="请输入验证码" autocomplete="new-password"/>
									<el-button class="normalBtn" ref="codeBtn" @click="getcode" id="codeBtn"
															:disabled="codeDisabled">获取验证码
									</el-button>
									<div class='validateTip'>{{validatetip2.code}}</div>
							</div>
							<div class="rightItem">
									<el-input class="input" v-model="resetform.pwd" maxlength="16" @keyup.enter="golost"
														placeholder="输入新密码" autocomplete="new-password"
														show-password/>
									<div class='validateTip'>{{validatetip2.pwd}}</div>
							</div>
							<div class="rightItem">
									<el-input class="input" v-model="resetform.pwd2" maxlength="16" @keyup.enter="golost"
														placeholder="确认新密码" autocomplete="new-password"
														show-password/>
									<div class='validateTip'>{{validatetip2.pwd2}}</div>
							</div>
							<div class="rightItem">
									<el-button plain class="enter wite" @click="goLogin" :loading="resetLoad">
											返回
									</el-button>
									<el-button plain class="enter" @click="golost" :loading="resetLoad">
											确认重置
									</el-button>
							</div>
            </div>
        </div>
    </div>
</template>
<script>
import { inviteEnterWatch } from "@/api/meeting";
import JsEncrypt from "jsencrypt";
import {
  userLoginByMobile,
  getSMSCode,
  resetUserPassWord,
  searchUserInfoByPhone
} from "@/api/login.js";
import { checkValidCode } from "@/api/user.js";
export default {
  data() {
    return {
      stid: 0,
      resetform: {
        phonenum: "",
        pwd: "",
        pwd2: "",
        code: ""
      },
      validatetip2: {
        phonenum: "",
        pwd: "",
        pwd2: "",
        code: ""
      },
      codeDisabled: false,
      resetLoad: false
    };
  },
  watch: {},
  mounted() {},
  methods: {
    checkresetphone() {
      if (!this.resetform.phonenum.trim()) {
        this.validatetip2.phonenum = "请输入手机号";
        return false;
      }
      let phoneReg = /^1[3-9]\d{9}$/;

      if (!phoneReg.test(this.resetform.phonenum.trim())) {
        this.validatetip2.phonenum = "手机号格式错误";
        return false;
      }
      this.validatetip2.phonenum = "";
      return true;
    },
    checkresetcode() {
      if (!this.resetform.code.trim()) {
        this.validatetip2.code = "请输入验证码";
        return false;
      }
      this.validatetip2.code = "";
      return true;
    },
    checkresetpwd() {
      let check = true;
      let passwordReg = /^(?!.*\s)(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[\W_]).{8,16}$/;
      if (!this.resetform.pwd.trim()) {
        this.validatetip2.pwd = "请输入密码";
        check = false;
      } else if (!passwordReg.test(this.resetform.pwd)) {
        this.validatetip2.pwd =
          "请输入8~16位数字和大小写字母及特殊字符组合的密码";
        check = false;
      }

      if (!this.resetform.pwd2.trim()) {
        this.validatetip2.pwd2 = "请再次输入密码";
        check = false;
      } else if (this.resetform.pwd != this.resetform.pwd2) {
        this.validatetip2.pwd2 = "两次密码不匹配，请重新输入";
        check = false;
      }

      if (check) {
        this.validatetip2.pwd = "";
        this.validatetip2.pwd2 = "";
      }
      return check;
    },
    getcode() {
      const self = this;
      let element = document.getElementById("codeBtn");
      if (!self.checkresetphone()) {
        return;
      }
      self.codeDisabled = true;
      searchUserInfoByPhone({ mobilePhone: self.resetform.phonenum }).then(
        res => {
          console.log(res);
          if (res.data.code === 1000 && res.data.data === 0) {
            this.$message({
              showClose: true,
              message: "无此账号",
              type: "error"
            });
          } else if (res.data.code === 1000 && res.data.data === 1) {
            getSMSCode({
              mobilePhone: self.resetform.phonenum,
              codeType: "SMS_RESET_PASSWORD_CODE"
            }).then(res => {
              console.log(res);
              if (res.data.code === 1000) {
                let count = 59;
                self.stid = setInterval(function() {
                  element.innerText = "还剩" + count + "S";
                  count--;
                  if (count < 0) {
                    element.innerText = "重新发送";
                    self.codeDisabled = false;
                    clearInterval(self.stid);
                  }
                }, 1000);
              } else {
                this.$message({
                  message: "短信发送失败",
                  type: "error"
                });
                clearInterval(self.stid);
                self.codeDisabled = false;
                element.innerText = "重新发送";
              }
            });
          }
        }
      );
    },
    // 重置密码
    golost() {
      let dologin = true;
      if (!this.checkresetphone()) {
        dologin = false;
      }
      if (!this.checkresetcode()) {
        dologin = false;
      }
      if (!this.checkresetpwd()) {
        dologin = false;
      }
      if (!dologin) {
        return;
      }
      this.resetLoad = true;
      // let encryptor = new JsEncrypt();
      // let rsaPassWord = encryptor.encrypt(this.resetform.pwd);
      let parms = {
        mobilePhone: this.resetform.phonenum,
        password: this.resetform.pwd,
        validateCode: this.resetform.code,
        personTypeEnum: "STAFF"
      };
      resetUserPassWord(parms).then(
        res => {
          let _this = this;
          if (res.data.code === 400 && res.data.message === "密码格式错误") {
            this.$message({
              message:
                "为响应国家强密码策略，现平台应仲裁院要求，对所有弱密码进行整改，密码强度需满足大小写字母、数字、特殊字符且长度不少于8个字符",
              type: "error"
            });
          }
          if (res.data.code === 1000) {
            this.$message({
              message: "密码重置成功, 3秒后返回登录",
              type: "success"
            });
            setTimeout(() => {
              _this.$router.push({ path: "/loginWorker" });
              _this.resetLoad = false;
            }, 3000);
          } else {
            this.resetLoad = false;
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        },
        err => {
          this.resetLoad = false;
        }
      );
      this.resetLoad = false;
    },
    goLogin() {
      this.$router.push({ path: "/loginWorker" });
    }
  },
  components: {}
};
</script>
<style lang="scss">
.invite_main {
  height: 100%;
  width: 100%;
  background: url("../../assets/bg.png") no-repeat center top;
  background-size: 100% 100%;
  .invite_header {
    display: flex;
    align-items: center;
    height: 110px;
    width: 85.5%;
    margin: 0 auto;
    color: #fff;
    .icon {
      position: relative;
      margin-right: 40px;
      .eng {
        font-size: 14px;
        letter-spacing: 25px;
      }
    }
    .icon:before {
      content: "";
      position: absolute;
      display: block;
      right: -10px;
      top: 10px;
      width: 1px;
      height: 0;
      border-top: 20px solid #ffffff;
    }
    .title {
      font-size: 28px;
      letter-spacing: 12px;
    }
  }
  .invite_content {
    position: relative;
    height: 80%;
    width: 85.5%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    background: url("../../assets/bg_content.png") no-repeat center top;
    background-size: 100% 100%;
    .invite-login {
      position: absolute;
      right: 83px;
      height: 500px;
      padding: 0 50px;
      background-color: #fff;
      border-radius: 4px;
      .rightItem {
        display: flex;
        margin-top: 30px;
        .validateTip {
          position: absolute;
          left: 50px;
          margin-top: 45px;
          color: red;
          line-height: 15px;
        }
        .speacail {
          width: 200px;
        }
        .normalBtn {
          border-radius: 0px;
          background-image: linear-gradient(90deg, #0083c8 0%, #142f9e 100%),
            linear-gradient(#0d44b0, #0d44b0);
          background-blend-mode: normal, normal;
          box-shadow: 0px 8px 18px 0px rgba(0, 59, 185, 0.3);
          background-blend-mode: normal, normal;
          color: #fff;
          cursor: pointer;
        }
        .enter {
          margin: 20px auto;
          width: 150px;
          height: 46px;
          display: flex;
          justify-content: center;
          align-items: center;
          background-image: linear-gradient(90deg, #0083c8 0%, #142f9e 100%),
            linear-gradient(#0d44b0, #0d44b0);
          background-blend-mode: normal, normal;
          box-shadow: 0px 8px 18px 0px rgba(0, 59, 185, 0.3);
          background-blend-mode: normal, normal;
          font-size: 18px;
          color: #fff;
          cursor: pointer;
        }
        .wite {
          background-image: none;
          color: #000000;
          box-shadow: none;
        }
      }
      .el-input__inner {
        border: 0;
        padding: 0;
        border-bottom: 1px solid #dcdfe6;
        border-radius: 0;
      }
    }
  }
}
</style>